<template lang="html">

  <div class="categoria-blog blog">


    <intro :data="$t(`blog.categorias_nombres.${this.$route.params.id}`)"></intro>

    <section class="destacados posts-cat">
      <div class="container">
        <p class="breadcrumb"><router-link :to="`/${this.lang}/${$t('enlaces.blog')}`">{{$t('enlaces.textos.blog')}}</router-link> / {{$t(`blog.categorias_nombres.${this.$route.params.id}`)}}</p>
        <div class="flex wrap justify-around pad-sec-pb0">
         <template v-if="!!noticias">
           <noticia-el v-if="e.titulo != null" v-for="(e, key) in showPrimeras" :data="e" :key="key"></noticia-el>
        </template>

        
        <template v-if="noticias.length == 0 && !no_post">
          <h2 class="title title-76">{{$t('blog.no_hay_post')}}</h2>
        </template>
      </div>
      <div class="btn-leer">
         <span class="btn btn-dark" v-if="contador < noticias.length" v-on:click="showMore">{{$t('genericos.leer_mas')}}</span>
      </div>
    </div>
  </section>


  <ultimas-noticias :small="true"></ultimas-noticias>


</div>



</template>

<script lang="js">

  import Intro from '@/components/view-parts/intros/blog'

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import { mapGetters } from 'vuex'

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';
  import Ultimas_noticias from '@/components/view-parts/actualidad-parts/noticias'
  
  export default  {
    name: 'categoria-blog',
    props: [],
    mounted() {
     axios.get(`blog/${this.$route.params.id}?lang=${this.lang}`)
     .then(response => {
      this.no_post = true;
      this.noticias = response.data.noticias
    })
     .catch(error => console.log(error));
   },
   data() {
    return {
      noticias : '',
      no_post : false,
      contador : 9
    }
  },
  methods: {
    showMore(){
    return this.contador = this.contador + 9
    }
  },
  computed : {
    ...mapGetters({
      lang: 'getLanguage',
    }),
    showPrimeras: function () {
    return this.noticias.slice(0, this.contador)
    }
  },
  components: {
    'intro' : Intro,
    'noticia-el' : Noticia_el,
    'ultimas-noticias' : Ultimas_noticias
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/categoria-blog.vue